if (!customElements.get('truncated-text')) {
  customElements.define(
    'truncated-text',
    class TruncatedText extends HTMLElement {
      constructor() {
        super();

        this.content = this.getElementsByClassName('content')[0];
        this.toggleButton = this.getElementsByClassName('toggle-truncation')[0];

        if (!this.content || !this.toggleButton) {
          return;
        }

        const useTruncation =
          Math.ceil(this.content.getBoundingClientRect().height) < Math.floor(this.content.scrollHeight);

        this.truncated = useTruncation;

        if (!useTruncation) {
          this.classList.remove('truncated');
          this.removeChild(this.toggleButton);
          return;
        }

        this.toggleButton.addEventListener('click', this.toggleTruncation);
      }

      removeTruncation() {
        this.truncated = false;
        this.toggleButton.innerHTML = 'Read Less';
        this.classList.remove('truncated');
      }

      addTruncation() {
        this.truncated = true;
        this.toggleButton.innerHTML = 'Read More';
        this.classList.add('truncated');
      }

      toggleTruncation = () => {
        this.truncated ? this.removeTruncation() : this.addTruncation();
      };
    }
  );
}
